// import React from 'react';
// import Navbar from './Navbar'; // Import the Navbar component

// const VideoPage = () => {
//   // You can replace these with actual YouTube video embed URLs
//   const videoUrls = [
//     "https://www.youtube.com/embed/AFx3pi2wcz0",
//     "https://www.youtube.com/embed/i_fWgFryZPw",
//     "https://www.youtube.com/embed/THRwVq_jp_I",
//     "https://www.youtube.com/embed/IRgZ0oxp2FE",
//     "https://www.youtube.com/embed/HVsK6T-3GsM",
//     "https://www.youtube.com/embed/N38sndMBn9s",
//     "https://www.youtube.com/embed/MNGkz94X2hU"
//   ];

//   return (
//     <>
//       <Navbar />

//       <div className="container mt-5">
//         <h2 className="text-center">Medical Infrared Imaging - Video Gallery</h2>
//         <div className="row">
//           {videoUrls.map((url, index) => (
//             <div key={index} className="col-md-6 col-lg-4 mb-4">
//               <div className="embed-responsive embed-responsive-16by9">
//                 <iframe
//                   src={url}
//                   className="embed-responsive-item"
//                   allowFullScreen
//                   title={`Video ${index + 1}`}
//                 ></iframe>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </>
//   );
// };

// export default VideoPage;


import React from 'react';
import Navbar from './Navbar'; // Import the Navbar component
import Footer from './FooterSection'; // Import the Navbar component
import './VideoPage.css';  // Import the external CSS file

const VideoPage = () => {
  // You can replace these with actual YouTube video embed URLs
  const videos = [
    {
      title: "How To Work Medical Breast Infrared Imaging Screening Modality.",  // Title for the video
      url: "https://www.youtube.com/embed/AFx3pi2wcz0"
    },
    {
      title: "Traditional Technologies Used To Diagnose Breast Cancer.",  
      url: "https://www.youtube.com/embed/i_fWgFryZPw"
    },
    {
      title: "How To Self Breast Examination For Breast Cancer Detection.",  
      url: "https://www.youtube.com/embed/THRwVq_jp_I"
    },
    {
      title: "Breast Cancer Early Detection",  
      url: "https://www.youtube.com/embed/IRgZ0oxp2FE"
    },
    {
      title: "Medical Digital Infrared Thermography. Explained",  
      url: "https://www.youtube.com/embed/HVsK6T-3GsM"
    },
    {
      title: "Who can do Digital Thermography?",  
      url: "https://www.youtube.com/embed/N38sndMBn9s"
    },
    {
      title: "Symptoms that Digital Thermography can detect",  
      url: "https://www.youtube.com/embed/MNGkz94X2hU"
    },
    {
      title: "How To Do Self Breast Examinations? Explained",  
      url: "https://www.youtube.com/embed/17icfbzEQo8"
    }
  ];

  return (
    <>
      <Navbar />

      {/* Background gradient applied here */}
      <div className="m-5"></div>
      <div className="video-page">
        <div className="container mt-5">
          <h2 className="text-center mb-2 title">Medical Infrared Imaging - Video Gallery</h2>
          <div className="why-thermal-line"></div>
          <div className="m-5"></div>
          <div className="row">
            {videos.map((video, index) => (
              <div key={index} className="col-md-6 col-lg-6 mb-4">
                {/* Video Title */}
                <h5 className="video-title">{video.title}</h5>
                
                <div className="embed-responsive">
                  <iframe
                    src={video.url}
                    className="embed-responsive-item"
                    allowFullScreen
                    title={`Video ${index + 1}`}
                  ></iframe>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
       <Footer />
    </>
  );
};

export default VideoPage;
